import { defineComponent, h } from 'vue';

export type SeasonalIconStyle = 'filled' | 'outline';

// Outline icons must stay unfilled even inside PageIcon, whose `svg.fill-path-current path` rule forces a fill with
// !important; only an inline !important beats it.
const OUTLINE_PATH_STYLE = 'fill: none !important';

// A seasonal stand-in icon on the Pulse 24-grid, coloured by currentColor like the Pulse line icons.
export function defineSeasonalIcon(name: string, d: string, style: SeasonalIconStyle = 'filled') {
  return defineComponent({
    name,
    setup: () => () => {
      if (style === 'filled') {
        return h('svg', { viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' }, [
          h('path', { d, 'fill-rule': 'evenodd' }),
        ]);
      }

      return h(
        'svg',
        {
          fill: 'none',
          stroke: 'currentColor',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': 1.8,
          viewBox: '0 0 24 24',
          xmlns: 'http://www.w3.org/2000/svg',
        },
        [h('path', { d, style: OUTLINE_PATH_STYLE })],
      );
    },
  });
}
